<template>
  <vue-form-generator
      :schema="schema"
      :model="model"
      :options="formOptions"
      ref="uploadForm"
  />
</template>

<script>

import {validateFileType} from "../../../validation/Vfg/resources";

export default {
  name: "DocumentUploadForm",
  props: {
    model: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      schema: {
        groups: [
          {
            styleClasses: "w-full",
            fields: [
              {
                type: "input",
                inputType: "text",
                styleClasses: "md:w-4/5 w-full",
                label: "Friendly Name",
                model: "FriendlyName",
                onChanged: (model, schema, event, instance) => {
                  if (!model.FriendlyName) {
                    delete model.FriendlyName;
                  }
                },
                validator: () => {
                  if (!this.model.FriendlyName
                      && (this.model.File || this.model.IsActiveDocument)
                  ) {
                    return 'This field is required';
                  }

                  return true;
                }
              },
              {
                type: "upload",
                inputType: "file",
                styleClasses: "w-full",
                label: "File",
                model: "File",
                placeholder: "",
                validator: [() => {
                  if (!this.model.File
                      && (this.model.FriendlyName || this.model.IsActiveDocument)
                  ) {
                    return 'Please upload a file';
                  }

                  if (this.model.File && this.model.File.size > 50000000) {
                    return 'The file selected is too large';
                  }

                  return true;
                }, validateFileType(['pdf','jpg','jpeg','png','doc','docx', 'xls', 'xlsm', 'xlsx'])],
                files: true,
                onChanged: (model, schema, event, instance) => {
                  this.model.File = instance.$el.children[0].files[0];
                },
              },
              {
                type: "vsCheckbox",
                styleClasses: "md:w-1/2 w-full",
                label: "Active",
                model: "IsActiveDocument",
                onChanged: (model, schema, event, instance) => {
                  model.IsActiveDocument = Number(model.IsActiveDocument);
                },
              },
            ],
          },
        ],
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      loading: false,
    }
  },
  methods: {
    validate() {
      return this.$refs['uploadForm'].validate();
    },
    hasExtension(fileName, exts) {
      return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
    }
  }
};
</script>

<style scoped>

</style>
